import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    open: false,
    step: '1',
    item: {
        id_widget   : '1', // no_return|with_return
        id_payment  : '',
        type_request: 'no_return', // no_return|with_return
        capacity_1  : '1',
        from_airport: false,
        org         : {
            address: '',
            lat    : 0,
            lng    : 0,
        },
        dst         : {
            address: '',
            lat    : 0,
            lng    : 0,
        },

        product: null,

        date_start : '',
        date_return: '',

        // tmp
        start_part_date : '',
        start_part_time : '',
        return_part_date: '',
        return_part_time: '',

        client: {
            email: '',
        },
    },
    data: null, // data inicial del widget
    fare: null, // data inicial del widget
};

const stateSlice = createSlice({
    name        : 'request/state',
    initialState: {...initialState},
    reducers    : {
        setStep: (state, action) => ({...state, step: action.payload}),
        setItem: (state, action) => ({...state, item: {...state.item, ...action.payload}}),
        setData: (state, action) => ({...state, data: action.payload}),
        setFare: (state, action) => ({...state, fare: action.payload}),
    },
});

export const {setStep, setItem, setData, setFare} = stateSlice.actions;

export const selectRequestState = ({request}) => request.state;

export default stateSlice.reducer;
